import { createReducer, on } from '@ngrx/store';
import { AiGenerationState, defaultAiState } from '@models/ai-generation.model';
import { AiActions } from '@store/actions/ai.actions';

export interface AiState extends AiGenerationState {
  apiKey: string;
}

const initialState: AiState = {
  ...defaultAiState,
  apiKey: ''
};

export const aiReducer = createReducer(
  initialState,

  on(AiActions.generateFrames, (state, { request }) => ({
    ...state,
    status: 'loading' as const,
    errorMessage: null,
    lastPrompt: request.prompt
  })),

  on(AiActions.generateFramesSuccess, (state) => ({
    ...state,
    status: 'success' as const,
    errorMessage: null
  })),

  on(AiActions.generateFramesFailure, (state, { error }) => ({
    ...state,
    status: 'error' as const,
    errorMessage: error
  })),

  on(AiActions.setApiKey, (state, { apiKey }) => ({
    ...state,
    apiKey
  })),

  on(AiActions.clearError, (state) => ({
    ...state,
    status: 'idle' as const,
    errorMessage: null
  }))
);
